'use strict';



const $ = require('jquery');
const $processing = $('[data-processing-investment]');
const getUrl = token => `/invest/${token}`;



if($processing.length > 0) {
	pollStatus(2000, 6000);
}



function pollStatus(interval = 800, maxInterval = 10000) {

	const token = $processing.data('processing-investment');
	const url = getUrl(token);
	const start = new Date().getTime();

	if(interval > maxInterval) {
		interval = maxInterval;
	}

	$.get(url, res => {

		if(res.processed === '1') {
			document.location.reload();
			return;
		}

		const duration = new Date().getTime() - start;

		const nextInterval = duration > 1500 ?
			interval * 3 :
			interval * 1.25;

		const nextPollStatus = pollStatus.bind(null, nextInterval, maxInterval);

		setTimeout(nextPollStatus, interval);

	});

}